import React from 'react';
import { Camera, Mic, Lightbulb, Scissors } from 'lucide-react';

const TrustBar = () => {
  const features = [
    { icon: Camera, text: 'Multi-Camera Filming' },
    { icon: Mic, text: 'Pro Audio Recording' },
    { icon: Lightbulb, text: 'Studio & Location Lighting' },
    { icon: Scissors, text: 'Editing + Post Production' }
  ];

  return (
    <section className="relative z-10 border-y border-white/[0.07] bg-white/[0.02]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/[0.07]">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="flex items-center gap-4 px-5 sm:px-8 py-8 group">
                <div className="w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center shrink-0 group-hover:bg-red-600/20 transition-colors">
                  <Icon className="h-4.5 w-4.5 text-red-500" style={{ width: 18, height: 18 }} />
                </div>
                <p className="text-sm font-medium text-gray-300 leading-snug">{feature.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
